/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* These rules are disabled because these eslint rules are deprecated and broken,
		even if you have a form control properly linked with forHTML it shows an error */
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import {
	getSettings,
	watchSettings,
	unwatchSettings,
	setSetting
} from '../utils/eventViewerSettings';

export default function ToggleSetting({
	setting,
	children = '',
	className = ''
}) {
	const [checked, setChecked] = useState(getSettings()[setting] || false);
	useEffect(() => {
		const onSettingsChange = (settings) => {
			setChecked(settings[setting] || false);
		};
		watchSettings(onSettingsChange);
		return function cleanup() {
			unwatchSettings(onSettingsChange);
		};
	});

	const onChange = () => {
		setSetting(setting, !checked);
	};
	return (
		<div className={`form-check ${className}`}>
			<label className="form-check-label">
				<input
					className="form-check-input"
					type="checkbox"
					onChange={onChange}
					checked={checked}
				/>
				&nbsp;
				{children}
			</label>
		</div>
	);
}
ToggleSetting.propTypes = {
	setting: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.element)
	]),
	className: PropTypes.string
};
